export default {
  token: 'f664abc2-2f12-423e-9a97-c253f9823fba',
  host: 'https://wchat.freshchat.com',
  open: false,
  locale: 'es',
  tags: ['Izzi'],
  faqTags: {
    tags: ['sample'],
    filterType: 'category',
  },
  config: {
    cssNames: {
      widget: 'fc_frame',
      open: 'fc_open',
      expanded: 'fc_expanded',
    },
    showFAQOnOpen: false,
    hideFAQ: true,
    agent: {
      hideName: true,
      hidePic: true,
      hideBio: true,
    },
    headerProperty: {
      appName: 'Soporte',
      appLogo: 'https://facturacionelectronica.izzinegocios.mx/icons/izzi.ico',
      backgroundColor: '#00BCEA',
      foregroundColor: '#FFFFFF',
    },
    content: {
      placeholders: {
        search_field: 'Buscar',
        reply_field: 'Responder',
        csat_reply: 'Agregue sus comentarios',
      },
      actions: {
        csat_yes: 'Sí',
        csat_no: 'No',
        push_notify_yes: 'Sí',
        push_notify_no: 'No',
        tab_faq: 'Soluciones',
        tab_chat: 'Chat',
        csat_submit: 'Enviar',
      },
      headers: {
        chat: 'Estamos para ayudarle',
        chat_help: '¿Tiene alguna pregunta?',
        faq: 'Preguntas frecuentes',
        faq_help: 'Consulte nuestras soluciones',
        faq_not_available: 'No se han encontrado resultados',
        faq_search_not_available: 'No se han encontrado resultados para {{query}}',
        faq_useful: '¿La solución le ha sido de utilidad?',
        faq_thankyou: 'Graciar por su valoración',
        faq_message_us: 'Déjenos un mensaje',
        push_notification: 'No se pierda ninguna respuesta. ¿Permitir notificaciones?',
        csat_question: '¿Hemos sido de ayuda?',
        csat_yes_question: '¿Cómo clasificaría la atención recibida?',
        csat_no_question: '¿En qué podriamos mejorar?',
        csat_thankyou: 'Gracias por su respsta',
        csat_rate_here: 'Envíe su valoración aquí',
        channel_response: {
          offline: 'Todos nuestros agentes están ocupados. Por favor déjanos un mensaje.',
          online: {
            minutos: {
              one: 'Actualmente contestando en {!time!} minuto(s) ',
              more: 'Normalmente contestamos en {!time!} minuto(s)',
            },
            hours: {
              one: 'Los tickets se contestan en menos de 1 hora',
              more: 'Normalmente se solucionan en {!time!} horas',
            },
          },
        },
      },
    },
  },
};
